import { ThemeConfig } from 'antd';
import deepmerge from 'deepmerge';

export interface AppToken {
  colorPrimaryGradient: string;
  colorTextOverPrimary: string;
  colorPrimaryLight: string;
  colorPrimary: string;
  colorPrimaryDarker: string;
}

export type AppThemeConfig = ThemeConfig & { token: AppToken };

export const base: AppThemeConfig = {
  token: {
    borderRadius: 8,
    screenXSMax: 576,
    screenSMMax: 640,
    screenMDMax: 768,
    screenLGMax: 1024,
    screenXLMax: 1280,
    // screenXXLMAX: 1536,
    fontFamily: 'var(--app-font-sans)',
    colorPrimary: '#4C8251',
    colorPrimaryLight: '#e1f0e3',
    colorTextOverPrimary: '#4C8251',
    colorPrimaryGradient: 'linear-gradient(148deg, #70db6f, #48b25a)',
    colorPrimaryDarker: '#4C8251',
  },
  components: {
    Button: {
      lineHeight: 1,
      fontSizeLG: 14,
      fontWeight: 500,
      controlHeightLG: 36,
    },
    Modal: {
      paddingContentHorizontal: 0,
      paddingContentVertical: 0,
    },
  },
};

export const nurture: AppThemeConfig = deepmerge(base, {
  token: {
    colorPrimary: '#4C8251',
    colorLink: '#4C8251',
    colorTextOverPrimary: '#4C8251',
    colorPrimaryGradient: 'linear-gradient(148deg, #70db6f, #48b25a)',
    colorPrimaryLight: '#e1f0e3',
    colorPrimaryDarker: '#4C8251',
  },
});

export const transport: AppThemeConfig = deepmerge(base, {
  token: {
    colorPrimary: '#FFD300',
    colorLink: '#FFD300',
    colorTextOverPrimary: '#333333',
    colorPrimaryGradient: 'linear-gradient(148deg, #cca900, #ffdc33)',
    colorPrimaryLight: '#ffdc33',
    colorPrimaryDarker: '#cca900',
  },
});

export const sport: AppThemeConfig = deepmerge(base, {
  token: {
    colorPrimary: '#C53F3F',
    colorLink: '#C53F3F',
    colorTextOverPrimary: '#C53F3F',
    colorPrimaryGradient: 'linear-gradient(148deg, #FEC89A, #FF8766)',
    colorPrimaryLight: '#F9ECEC',
    colorPrimaryDarker: '#9E3232',
  },
});

export const helpdesk: AppThemeConfig = deepmerge(base, {
  token: {
    colorPrimary: '#b08712',
    colorLink: '#b08712',
    colorTextOverPrimary: '#b08712',
    colorPrimaryGradient:
      'linear-gradient(148deg, rgb(241, 209, 121), rgb(234, 186, 49))',
    colorPrimaryLight: '#fff3d3',
    colorPrimaryDarker: '#96720e',
  },
});

export const dormitory: AppThemeConfig = deepmerge(base, {
  token: {
    colorPrimary: '#75604C',
    colorLink: '#75604C',
    colorTextOverPrimary: '#75604C',
    colorPrimaryGradient: 'linear-gradient(148deg, #E2D5C9, rgb(162 122 85))',
    colorPrimaryLight: '#E2D5C9',
    colorPrimaryBg: '#E2D5C9',
    colorPrimaryDarker: '#75604C', // same as primary
  },
});

export const health: AppThemeConfig = deepmerge(base, {
  token: {
    colorPrimary: '#71DFE7',
    colorLink: '#71DFE7',
    colorTextOverPrimary: '#009DAE',
    colorPrimaryGradient: 'linear-gradient(148deg, #009DAE, #C2FFF9)',
    colorPrimaryLight: '#C2FFF9',
    colorPrimaryDarker: '#009DAE',
  },
});

export const face: AppThemeConfig = deepmerge(base, {
  token: {
    colorPrimary: '#6c467c',
    colorLink: '#8e44ad',
    colorTextOverPrimary: '#672d80',
    colorPrimaryGradient: 'linear-gradient(148deg, #e0c5eb, #e0d3e6)',
    colorPrimaryLight: '#f5ecf9',
    colorPrimaryDarker: '#e0c5eb',
  },
});

export const survey: AppThemeConfig = deepmerge(base, {
  token: {
    colorPrimary: '#db9637',
    colorLink: '#db9637',
    colorTextOverPrimary: '#996300',
    colorPrimaryGradient: 'linear-gradient(148deg, #ffc370, #f7c681)',
    colorPrimaryLight: '#ffdfb3',
    colorPrimaryDarker: '#996300',
  },
});

export default {
  base,
  sport,
  nurture,
  helpdesk,
  transport,
  dormitory,
  health,
  face,
  survey
};
